<template>
  <div class="filters">
    <div class="filters__wrap">
      <ul class="filters__list">
        <SingleFilter
            v-if="years"
            :title="Filter.YEAR"
            :filter="years"
            :selectedCount="selectedYears"
        />
        <SingleFilter
            v-if="altitude"
            :title="Filter.ALTITUDE"
            :filter="altitude"
            :selectedCount="selectedAltitude"
        />
        <SingleFilter
            v-if="media"
            :title="Filter.MEDIA"
            :filter="media"
            :selectedCount="selectedMedia"
        />
        <SingleFilter
            v-if="specifics"
            :title="Filter.SPECIFIC"
            :filter="specifics"
            :selectedCount="selectedSpecific"
        />
        <li
            @click="resetFilters"
            class="filters__clear"
            :class="{ activeClass: isFilterActive }"
        >
          Clear Filters
        </li>
      </ul>
      <div @click="setIsMapOpen(!isMapOpen)" class="filter__map">
        <svg>
          <use :xlink:href="isMapOpen ? '#icon-list-light' : '#icon-map-light'"></use>
        </svg>
        {{ isMapOpen ? "List" : "Map" }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {Filter} from "../../../utils/types.ts";
import SingleFilter from "./SingleFilter.vue";
import {useCategoryStore} from "../../../store/category.ts";
import {useMapStore} from "../../../store/map.ts";
import {useProductStore} from "../../../store/product.ts";
import {storeToRefs} from "pinia";

const {years, altitude, media, specifics} = useCategoryStore();

const mapStore = useMapStore()
const {setIsMapOpen} = mapStore;
const {isMapOpen} = storeToRefs(mapStore)

const productStore = useProductStore();
const {resetFilters} = productStore;
const {isFilterActive, selectedYears, selectedAltitude, selectedMedia, selectedSpecific} =
    storeToRefs(productStore);
</script>
